import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RoundOffAmountFetchRequest, RoundOffAmountFetchResponse, RoundOffSaving, RoundOffSavingCreateRequest, RoundOffSavingDeleteRequest, RoundOffSavingList, RoundOffSavingReadByIdRequest, RoundOffSavingReadByUserIdRequest, RoundOffSavingUpdateRequest } from './roundoff-savings.interface';
import { RoundOffSavings_Create, RoundOffSavings_Delete, RoundOffSavings_ReadAll, RoundOffSavings_ReadById, RoundOffSavings_ReadByUserId, RoundOffSavings_RoundOffAmountFetch, RoundOffSavings_Update } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class RoundoffSavingsService {

  constructor() { }
  http = inject(HttpClient)

  RoundOffSavings_ReadAll(): Observable<RoundOffSavingList> {
    return this.http.get<RoundOffSavingList>(RoundOffSavings_ReadAll)
  }
  RoundOffSavings_Create(RoundOffSavings: RoundOffSavingCreateRequest): Observable<RoundOffSaving> {
    return this.http.post<RoundOffSaving>(RoundOffSavings_Create, RoundOffSavings);
  }

  RoundOffSavings_Update(RoundOffSavings: RoundOffSavingUpdateRequest): Observable<RoundOffSaving> {
    return this.http.post<RoundOffSaving>(RoundOffSavings_Update, RoundOffSavings);
  }

  RoundOffSavings_Delete(data: RoundOffSavingDeleteRequest): Observable<void> {
    return this.http.post<void>(RoundOffSavings_Delete, data)
  }

  RoundOffSavings_ReadById(data: RoundOffSavingReadByIdRequest): Observable<RoundOffSaving> {
    return this.http.post<RoundOffSaving>(RoundOffSavings_ReadById, data);
  }

  RoundOffSavings_ReadByUserId(data: RoundOffSavingReadByUserIdRequest): Observable<RoundOffSaving> {
    return this.http.post<RoundOffSaving>(RoundOffSavings_ReadByUserId, data);
  }
  RoundOffSavings_RoundOffAmountFetch(data: RoundOffAmountFetchRequest): Observable<RoundOffAmountFetchResponse> {
    return this.http.post<RoundOffAmountFetchResponse>(RoundOffSavings_RoundOffAmountFetch, data);
  }
}
